export enum ReelState {
    IDLE = "idle",
    INACTIVE = "inactive",

    // Spin states.
    START = "start",
    SPIN = "spin",
    STOPPING = "stopping",
    BOUNCE = "bounce",
    STOPPED = "stopped"
}

export interface IReelStateEventData {
    reelId: number;
    newState: ReelState;
    oldState: ReelState;
}